import { VestingGraphPointGranularity } from '../../../../../hooks/vesting-task/use-vesting-graph';

const NARROW_SCREEN_MIN_WIDTH_PX = 640;
const WIDE_SCREEN_MIN_WIDTH_PX = 720;

export type VestingGraphVariant = {
  originalScheduleOpacity: number;
  resolveChartMinWidth: (input: { isNarrowScreen: boolean; pointCount: number }) => number;
  /** Milestone schedules bracket and divide each target instead of reading as one curve. */
  showMilestoneMarkers: boolean;
  showValueBars: boolean;
  statusAreaOpacity?: { projected: number; vested: number };
  topMargin: number;
};

const resolveMinWidth = ({
  isNarrowScreen,
  pointCount,
  pointWidthPx,
}: {
  isNarrowScreen: boolean;
  pointCount: number;
  pointWidthPx: number;
}) =>
  Math.max(
    isNarrowScreen ? NARROW_SCREEN_MIN_WIDTH_PX : WIDE_SCREEN_MIN_WIDTH_PX,
    Math.max(pointCount, 2) * pointWidthPx,
  );

export const vestingGraphVariantByGranularity: Record<
  VestingGraphPointGranularity,
  VestingGraphVariant
> = {
  [VestingGraphPointGranularity.MILESTONE]: {
    originalScheduleOpacity: 0.45,
    resolveChartMinWidth: ({ isNarrowScreen, pointCount }) =>
      resolveMinWidth({ isNarrowScreen, pointCount, pointWidthPx: 140 }),
    showMilestoneMarkers: true,
    showValueBars: false,
    statusAreaOpacity: { projected: 0.45, vested: 1 },
    topMargin: 72,
  },
  [VestingGraphPointGranularity.MONTHLY]: {
    originalScheduleOpacity: 0.45,
    resolveChartMinWidth: ({ isNarrowScreen, pointCount }) =>
      resolveMinWidth({ isNarrowScreen, pointCount, pointWidthPx: 28 }),
    showMilestoneMarkers: false,
    showValueBars: true,
    topMargin: 48,
  },
};
